module.exports = __webpack_public_path__ + "static/media/twitter-dark-blue.9888ae55.svg";